import React from "react";

const Preview = ({ children }) => {
  return <div className="demo-preview">{children}</div>;
};

export default Preview;
